import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
} from "@/components/help/help-ui";

const controls = () => [
  i18n.t("help.privacy.items.visibility"),
  i18n.t("help.privacy.items.blocked"),
  i18n.t("help.privacy.items.export"),
  i18n.t("help.privacy.items.notifications"),
];

/**
 * Deletion gets its own section rather than a bullet among the controls.
 *
 * A store subscription is billed by Apple or Google, and `deleteAccount` only
 * cancels the one our own payment provider holds — so somebody who deletes
 * their account while holding an App Store subscription keeps being charged by
 * a company we cannot bill on behalf of. That is a refund and a complaint, and
 * one line here prevents it.
 */
const deletion = () => [
  i18n.t("help.privacy.deleteWhere"),
  i18n.t("help.privacy.deleteKept"),
  i18n.t("help.privacy.deleteStore"),
];

export default function PrivacyAccount() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.privacy.title")}>
      <HelpIntro>{i18n.t("help.privacy.intro")}</HelpIntro>

      <HelpSection
        heading={i18n.t("help.privacy.controls")}
        bullets={controls()}
      />

      <HelpSection
        heading={i18n.t("help.privacy.deletion")}
        bullets={deletion()}
      />

      <HelpSection heading={i18n.t("help.privacy.policies")} />
      <HelpButton
        label={i18n.t("help.privacy.privacyPolicy")}
        icon="document-text-outline"
        variant="secondary"
        onPress={() => router.push("/legal/privacy-policy")}
      />
      <HelpButton
        label={i18n.t("help.privacy.terms")}
        icon="document-text-outline"
        variant="secondary"
        onPress={() => router.push("/legal/terms-of-service")}
      />
    </HelpScreen>
  );
}
